import { render, staticRenderFns } from "./TemplateB.vue?vue&type=template&id=d1b8f774&scoped=true&"
import script from "./TemplateB.vue?vue&type=script&lang=js&"
export * from "./TemplateB.vue?vue&type=script&lang=js&"
import style0 from "./TemplateB.vue?vue&type=style&index=0&id=d1b8f774&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b8f774",
  null
  
)

export default component.exports